"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContentTraverser_1 = require("../contentTraverser/ContentTraverser");
var createRange_1 = require("../selection/createRange");
var Position_1 = require("../selection/Position");
var getLeafSibling_1 = require("../utils/getLeafSibling");
/**
 * Get all block elements covered by the selection under this region
 */
function getSelectedBlockElementsInRegion(region) {
    if (!region) {
        return [];
    }
    var nodeBefore = region.nodeBefore, nodeAfter = region.nodeAfter, rootNode = region.rootNode, skipTags = region.skipTags, fullSelectionEnd = region.fullSelectionEnd, fullSelectionStart = region.fullSelectionStart;
    var startNode = nodeBefore
        ? getLeafSibling_1.getNextLeafSibling(region.rootNode, nodeBefore, region.skipTags)
        : rootNode.firstChild;
    var endNode = nodeAfter
        ? getLeafSibling_1.getPreviousLeafSibling(rootNode, nodeAfter, skipTags)
        : rootNode.lastChild;
    var blocks = [];
    if (startNode && endNode) {
        var regionRange = createRange_1.default(startNode, endNode);
        var regionStart = Position_1.default.getStart(regionRange).normalize();
        var regionEnd = Position_1.default.getEnd(regionRange).normalize();
        if (!fullSelectionStart.isAfter(regionEnd) && !regionStart.isAfter(fullSelectionEnd)) {
            var start = fullSelectionStart.isAfter(regionStart)
                ? fullSelectionStart
                : regionStart;
            var end = fullSelectionEnd.isAfter(regionEnd) ? regionEnd : fullSelectionEnd;
            var range = createRange_1.default(start, end);
            var traverser = ContentTraverser_1.default.createSelectionTraverser(rootNode, range, skipTags);
            for (var block = traverser === null || traverser === void 0 ? void 0 : traverser.currentBlockElement; !!block; block = traverser.getNextBlockElement()) {
                blocks.push(block);
            }
        }
    }
    return blocks;
}
exports.default = getSelectedBlockElementsInRegion;
//# sourceMappingURL=getSelectedBlockElementsInRegion.js.map